import React, {Component} from "react";
import {FormGroup, FormControl, ControlLabel, Col} from "react-bootstrap";
import Select, { components } from "react-select"
import Creatable from "react-select/lib/Creatable"

export default class InlineForm extends Component {
    // static
    static static({
                      controlId,
                      labelCol = 12,
                      formCol = 12,
                      label = "",
                      required,
                      children,
                      ...props
                  }) {
        return (
            <FormGroup controlId={controlId}>
                {label !== "" && labelCol !== 0 &&
                <Col componentClass={ControlLabel} sm={labelCol}>
                    {label}
                    {required && "（*）"}
                </Col>
                }
                <Col sm={formCol = 12}>
                    <FormControl.Static {...props}>
                        {children}
                    </FormControl.Static>
                </Col>
            </FormGroup>
        );
    }

    getType({
                children,
                type = ""
            }) {
        let resultData = type;

        if (children) {
            resultData = "children";
        }

        return resultData;
    }

    selectDataSetting({value, options}) {
        let getValue = value;

        if (Array.isArray(getValue)) {
            let tmp = getValue;
            getValue = [];
            tmp.forEach(tmpValue => {
                let findData = options.find(option => option && option.value.toString() === tmpValue.toString());

                if (findData) {
                    getValue.push(findData);
                }
                // creatable の場合、未定義の値はそのまま表示できるように補完
                else if (this.props.isCreatable && (tmpValue !== null && tmpValue !== undefined && tmpValue !== "")) {
                    getValue.push({ label: tmpValue.toString(), value: tmpValue });
                }
            });
        } else {
            getValue = value !== "" ? options.find(option => option && option.value === getValue) : value;
        }

        return getValue;
    }

    render() {
        let {
            children,
            controlId,
            label = "",
            labelCol = 12,
            formCol = 12,
            required = false,
            value = null,
            validationState,
            colWidth,
            ...props
        } = this.props;

        /*validationStateはsuccess,warning,error,nullしか対応しないため、
        validationStateがbooleanのときnullかerrorに変換*/
        if(validationState===true){
            validationState=null
        }else if(validationState===false){
            validationState='error'
        }

        let type = this.getType({children, type: props.type});

        return (
            <FormGroup controlId={controlId} validationState={validationState} className={colWidth ? "margin-bottom-0" : ""}>
                {label !== "" && labelCol !== 0 && !colWidth &&
                    <Col componentClass={ControlLabel} sm={labelCol}>
                        {label}
                        {required && "*"}
                    </Col>
                }
                {/* ラベル表示無し、Col3だけほしい場合 */}
                {label === "" && this.props.nulllabel === "on" &&
                    <Col sm={labelCol}>
                    </Col>
                }
                <Col sm={colWidth ? colWidth : formCol}>
                    {type === "children" &&
                    <div>
                    {children}
                    </div>
                    }
                    {type === "select" &&
                    (() => {
                        let mergedComponents = props.components || {};
                        if (props.selectAllEnabled) {
                            const MenuList = (menuProps) => {
                                const { selectProps, children } = menuProps;
                                const inputValue = (selectProps.inputValue || "").toString();
                                const label = inputValue
                                    ? (selectProps.selectAllFilteredLabel || "")
                                    : (selectProps.selectAllLabel || "");

                                // フィルター対象のオプションを全量(選択済み含む)から作る
                                const flattenOptions = (opts) => {
                                    if (!Array.isArray(opts)) return [];
                                    let result = [];
                                    opts.forEach(o => {
                                        if (o && Array.isArray(o.options)) result = result.concat(o.options);
                                        else if (o) result.push(o);
                                    });
                                    return result;
                                };

                                const allOptions = flattenOptions(selectProps.options);
                                const q = inputValue.trim().toLowerCase();
                                const matches = (opt) => {
                                    if (!q) return true;
                                    const lbl = (opt.label || "").toString().toLowerCase();
                                    const val = (opt.value || "").toString().toLowerCase();
                                    return lbl.includes(q) || val.includes(q);
                                };
                                const filteredOptions = allOptions.filter(matches);

                                const currentValues = Array.isArray(selectProps.value)
                                    ? selectProps.value
                                    : (selectProps.value ? [selectProps.value] : []);

                                const isAllSelected = filteredOptions.length > 0
                                    && filteredOptions.every(opt => currentValues.find(v => v && v.value === opt.value));

                                const onToggle = (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    let nextValues = [];
                                    if (isAllSelected) {
                                        const removeSet = new Set(filteredOptions.map(o => o.value));
                                        nextValues = currentValues.filter(v => !removeSet.has(v.value));
                                    } else {
                                        const map = new Map(currentValues.map(v => [v.value, v]));
                                        filteredOptions.forEach(o => map.set(o.value, o));
                                        nextValues = Array.from(map.values());
                                    }
                                    selectProps.onChange(nextValues, { action: 'select-option', option: null });
                                };

                                return (
                                    <components.MenuList {...menuProps}>
                                        <div
                                            onMouseDown={onToggle}
                                            onClick={(e) => e.preventDefault()}
                                            style={{
                                                padding: '6px 12px',
                                                borderBottom: '1px solid #eee',
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <input type="checkbox" readOnly checked={isAllSelected} style={{ marginRight: 8 }} />
                                            <span>{label}</span>
                                        </div>
                                        {children}
                                    </components.MenuList>
                                );
                            };
                            mergedComponents = { ...mergedComponents, MenuList };
                        }
                        const SelectComponent = this.props.isCreatable ? Creatable : Select;
                        return (
                            <SelectComponent
                                id={controlId}
                                {...props}
                                components={mergedComponents}
                                value={this.selectDataSetting({ value, options: this.props.options })}
                            />
                        );
                    })()
                    }
                    {type !== "children" && type !== "select" &&
                    <FormControl
                        value={value}
                        {...props}
                    />
                    }
                </Col>
            </FormGroup>
        );
    }
}
